<div class="repo-contacts-popup">
  <div class="modal-header">
    <h5 class="modal-title" id="permissionModalLabel">{{contact?.repoBusiness?.businessName}} Contact</h5>
    <div class="d-flex justify-content-end ms-auto">
      <button type="button" class="btn col-auto me-2 btn-secondary" (click)="dismissPopup()"><i class="fa fa-times"></i> Cancel</button>
      <button type="button" class="btn col-auto btn-primary" (click)="saveContact()"><i class="fa fa-save"></i> Save</button>
    </div>

  </div>
  <div class="modal-body">
    <app-repocontact-edit #repoContactEdit [contact]="contact" [isUSA]="isUSA"  [isShowOrgDropDown]="true" (contactSaved)="contactSaved($event)"></app-repocontact-edit>
  </div>
</div>
